import React from "react";
import { Twitter, Linkedin, Instagram, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="w-full py-12 border-t border-[var(--outline-variant)]/20 bg-[var(--surface-container-lowest)]">
      <div className="tonal-shift">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-7xl mx-auto px-6 lg:px-8">
          {/* Brand Column */}
          <div className="space-y-6">
            <div className="text-lg font-black text-[var(--primary)] font-headline uppercase tracking-headline">
              Kravion
            </div>
            <p className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)] leading-relaxed max-w-xs">
              High-performance engineering for the digital vanguard.
            </p>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col space-y-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)] hover:text-[var(--secondary)] transition-colors opacity-80 hover:opacity-100 inline-flex items-center gap-2"
              >
                <Twitter size={14} strokeWidth={1.5} />
                Twitter
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)] hover:text-[var(--secondary)] transition-colors opacity-80 hover:opacity-100 inline-flex items-center gap-2"
              >
                <Linkedin size={14} strokeWidth={1.5} />
                LinkedIn
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)] hover:text-[var(--secondary)] transition-colors opacity-80 hover:opacity-100 inline-flex items-center gap-2"
              >
                <Instagram size={14} strokeWidth={1.5} />
                Instagram
              </a>
            </div>
            <div className="flex flex-col space-y-4">
              <a
                href="mailto:hello@kineticether.com"
                className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)] hover:text-[var(--secondary)] transition-colors opacity-80 hover:opacity-100 inline-flex items-center gap-2"
              >
                <Mail size={14} strokeWidth={1.5} />
                Newsletter
              </a>
              <a
                href="#"
                className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)] hover:text-[var(--secondary)] transition-colors opacity-80 hover:opacity-100"
              >
                Legal
              </a>
            </div>
          </div>

          {/* Office Info */}
          <div className="flex flex-col space-y-4 md:text-right">
            <p className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)]">
              Office: San Francisco
            </p>
            <p className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)]">
              Office: London
            </p>
            <div className="pt-4">
              <p className="font-body text-xs tracking-code uppercase text-[var(--outline-variant)]">
                © 2025 Kravion ALL RIGHTS RESERVED.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
